export default "__VITE_ASSET__BBeaP$Lg__"